// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-container_root__o5jyJ","article":"tweet-container_article__JeOqu"};